module.exports = __webpack_public_path__ + "img/jametlene_reskp_fliw_xjiWN.37c93bbf.jpg";